import { useField, useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import { FormControl, FormControlLabel, FormHelperText, Grid, Radio, RadioGroup, Typography } from '@material-ui/core';
import styled from 'styled-components';
const StyledGrid = styled(Grid) `
  .error-label {
    color: ${props => props.theme.palette.error.main};
  }
`;
export const InlineRadioGroup = props => {
    let { label, name, disabled, isBoolean, error, options, grid } = props;
    const formik = useFormikContext();
    const [field, meta, { setValue }] = useField(props);
    if (!grid) {
        // default field to expand entire width of form
        grid = { xs: 12 };
    }
    return useMemo(() => (React.createElement(StyledGrid, Object.assign({ item: true }, grid),
        label && (React.createElement(Typography, { variant: 'h5', className: error || meta.error ? 'error-label' : '' }, label)),
        React.createElement(FormControl, { name: name, error: meta.touched && Boolean(meta.error), component: 'fieldset' },
            React.createElement(RadioGroup, Object.assign({ row: true, "aria-label": label }, field, { name: name, onChange: event => {
                    if (isBoolean) {
                        setValue(event.target.value === 'true');
                    }
                    else {
                        setValue(event.target.value);
                    }
                    formik.submitForm();
                } }), options.map(option => typeof option === 'string' ? (React.createElement(FormControlLabel, { key: option, value: option, control: React.createElement(Radio, { color: 'primary' }), label: option, disabled: disabled })) : (React.createElement(FormControlLabel, { key: option.value.toString(), value: option.value, control: React.createElement(Radio, { color: 'primary' }), label: option.label, disabled: disabled }))))),
        (error || meta.error) && (React.createElement(FormHelperText, { error: true }, error || meta.error)))), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [field.value, meta.error, name, label, options]);
};
export default InlineRadioGroup;
//# sourceMappingURL=InlineRadioGroup.js.map